import React from 'react';

import Logo from '../../assets/images/logo.png'

import './styles.scss';

function Landing() {

    return (
        <div id="page-landing">
            <div className="logo">
                <div className="logo-container">
                    <img src={Logo} alt="Logo" />
                </div>
                <div className="title">
                    <p className="auroreal">AUROREAL</p>
                    <p className="consulting">CONSULTING</p>
                </div>
            </div>
            <div className="under-construction">
                <p className="construction-text">UNDER CONSTRUCTION</p>
            </div>
        </div>
    )
}

export default Landing;